export class Storage {

  static prefix = 'medicine_backend_';

  static set(field, data) {
    window.localStorage.setItem(this.prefix + field, data);
  }

  static get(field) {
    const value = window.localStorage.getItem(this.prefix + field);
    return value;
  }

  static remove(field) {
    window.localStorage.removeItem(this.prefix + field);
  }

  static getParse(field) {
    const value = window.localStorage.getItem(this.prefix + field);
    try {
      return value? JSON.parse(value): '';
    } catch (error) {
      return '';
    }
  }

  static clear() {
    window.localStorage.clear();
  }
}